import React, { useState } from "react";
import './Navbar.css';
import SignUpForm from './Signup';
import { Link } from "react-router-dom";

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const handlePricingClick = (e) => {
    e.preventDefault();
    const pricingSection = document.getElementById('pricing');
    if (pricingSection) {
      pricingSection.scrollIntoView({ behavior: 'smooth' });
    }
    closeMobileMenu();
  };

  return (
    <header className="navbar" role="banner">
      <div className="navbar-container">
        <div className="logo-section">
          <Link to="/" aria-label="LeetEng Home" onClick={closeMobileMenu}>
            <img
              src="/Leet Logo.png"
              alt="LeetEng Logo"
              className="logo-image"
            />
          </Link>
        </div>

        {/* Desktop Navigation */}
        <nav className="nav-section" role="navigation" aria-label="Main navigation">
          <ul className="nav-list">
            <li className="nav-item">
              <Link to="/about" className="nav-link">About</Link>
            </li>
            <li className="nav-item">
              <a href="#pricing" className="nav-link" onClick={handlePricingClick}>Pricing</a>
            </li>
            <li className="nav-item">
              <Link to="/dashboard" className="nav-link">Platform</Link>
            </li>
          </ul>
        </nav>

        {/* Hamburger Menu Button */}
        <button 
          className={`hamburger-menu ${isMobileMenuOpen ? 'open' : ''}`}
          onClick={toggleMobileMenu}
          aria-label={isMobileMenuOpen ? "Close menu" : "Open menu"}
          aria-expanded={isMobileMenuOpen}
        >
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
        </button>

        {/* Desktop Auth Section */}
        <div className="auth-section desktop-auth">
          <SignUpForm />
        </div>
      </div>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${isMobileMenuOpen ? 'open' : ''}`}>
        <ul className="mobile-nav-list">
          <li className="mobile-nav-item">
            <Link to="/about" className="mobile-nav-link" onClick={closeMobileMenu}>
              About
            </Link>
          </li>
          <li className="mobile-nav-item">
            <a href="#pricing" className="mobile-nav-link" onClick={handlePricingClick}>
              Pricing
            </a>
          </li>
          <li className="mobile-nav-item">
            <Link to="/dashboard" className="mobile-nav-link" onClick={closeMobileMenu}>
              Platform
            </Link>
          </li>
          
          {/* Mobile Auth Buttons */}
          <li className="mobile-nav-item mobile-auth-item">
            <div className="mobile-auth-section">
              <SignUpForm />
            </div>
          </li>
        </ul>
      </div>
    </header>
  );
};

export default Navbar;
